import React from 'react';
import { InventoryStoreProvider } from 'contexts/inventory-store.context';
import InventoryStoreContent from './content';

const InventoryStoreLayout = () => {
  return (
    <InventoryStoreProvider>
      <InventoryStoreContent />
    </InventoryStoreProvider>
  );
};

export default InventoryStoreLayout;
